import { FraudTaskStatusEnum } from "./enums/FraudTaskStatusEnum"

export class AvailableActions {
  actions: Action[]
  messages: MessageAction[]
}

export class Action {
  currentStatus: string
  nextStatus: FraudTaskStatusEnum
  class: any
  title: string
  actionId: number
  apiName: string
}
export class MessageAction {
  message: string
  image: string
}
